import QueryParameterBuilder from '@/lib/query-parameter/QueryParameterBuilder';
import { memberCompanyInquiryApi } from '@/api/member-company-inquiry';
import MemberCompanyInquiry from '@/entity/MemberCompanyInquiry';
import PaginationOutput from '@/helpers/PaginationOutput';
export const memberCompanyInquiryService = {
    async getItemList(param = {
        pageNumber: 1,
        pageSize: '20',
        workerType: '',
        searchType: '',
        searchText: '',
    }) {
        const params = new QueryParameterBuilder()
            .addPage(param.pageNumber)
            .addSize(param.pageSize);
        if (param.workerType) {
            params.add('type', param.workerType);
        }
        if (param.searchText) {
            params.add('searchType', param.searchType);
            params.add('SearchText', param.searchText);
        }
        const response = await memberCompanyInquiryApi.getItemList(params.build());
        return PaginationOutput.adaptorFactory(response, MemberCompanyInquiry);
    },
    /**
     * 단건 조회
     */
    async getItem(id) {
        const response = await memberCompanyInquiryApi.getItem(id);
        const { comments, ...data } = response.data.data; // comments와 나머지 데이터를 분리
        const inquiry = new MemberCompanyInquiry(data); // MemberCompanyInquiry 객체 생성
        // comments를 MemberCompanyInquiry에 정의된 변수를 이용하여 변환
        const formattedComments = comments.map((comment) => new MemberCompanyInquiry({
            commentContent: comment.content || '',
            commentProcessingType: comment.processingType || '',
            commentCreatedAt: comment.createdAt || '',
        }));
        return {
            inquiry,
            comments: formattedComments,
        }; // inquiry와 comments를 함께 반환
    },
    /**
     * 템블릿 조회
     */
    async getTempList() {
        const response = await memberCompanyInquiryApi.getTempList();
        const templates = response.data.data.map((item) => {
            const { type, template } = item;
            return {
                type,
                template: template
                    ? new MemberCompanyInquiry({
                        title: template.title,
                        body: template.body,
                        createdAt: template.createdAt,
                        createdBy: template.createdBy,
                    })
                    : null,
            };
        });
        return templates;
    },
    /**
     * 단건 등록
     */
    async createItem(serviceData) {
        const response = await memberCompanyInquiryApi.postItem(serviceData.createReqBody());
        return response.data;
    },
    /**
     * 단건 삭제
     */
    async deleteItem(id) {
        const response = await memberCompanyInquiryApi.deleteItem(id);
        return response;
    },
    /**
     * 단건 수정
     */
    async updateItem(serviceData) {
        const response = await memberCompanyInquiryApi.putItem(serviceData.reqBody.id, serviceData.createReqBody());
        return response;
    },
};
